import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#79A341',
        secondary: '#D9D9D9',
      },
    },
  },
}

export default new Vuetify(opts)
